import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Img = styled.img`
  border-radius: 4px;
  flex: 0 0 auto;
  margin-right: 20px;
  width: 65px;
  height: 65px;
  object-fit: cover;
  object-position: center;
  ${props => props.theme.isExpanded && `
    width: 130px;
    height: 130px;
  `}
  ${props => props.theme.isOnWireSide && `
    width: 115px;
    height: 115px;
    margin: 0;
  `}
`;

export default function Avatar({
  slug, profilePictureUrl, name, clickDataAttributes, clickHandler,
}) {
  return (
    <a
      href={slug ? `/contributors/${slug}` : '#'}
      {...clickDataAttributes}
      onClick={clickHandler}
    >
      <Img
        src={profilePictureUrl || window.getLivewireAssetPath('avatar-fallback.png')}
        alt={name}
      />
    </a>
  );
}

Avatar.propTypes = {
  slug: PropTypes.string,
  name: PropTypes.string.isRequired,
  profilePictureUrl: PropTypes.string,
  clickDataAttributes: PropTypes.shape({}),
  clickHandler: PropTypes.func,
};

Avatar.defaultProps = {
  profilePictureUrl: null,
  slug: null,
  clickDataAttributes: null,
  clickHandler: null,
};
